<template lang="pug">
  .center-vertical.bg-primary
    .empty
      p.empty-title.h5 Departamentos
      .loading(v-if='status == "loading"')
      div(v-else-if="errorMessage || list.length == 0")
        .toast.toast-error.mb-2 {{errorMessage || 'Você não tem permissão para acessar este módulo'}}
        .btn.btn-ersror.mt-2(@click='sair')
          i.fa.fa-power-off.fa-fw
          | &nbsp;Sair
      div(v-else)
        p.empty-subtitle Selecione um departamento
        table.table.table-hover
          tbody
            tr.c-hand(v-for='d in list' @click='setDepartamento(d)')
              td {{d.nome}}
              td.text-right
                i.fa.fa-angle-right.fa-lg
</template>

<script>
export default {
  vuex: {
    session: {
      state: ['usuario'],
      actions: ['signOut'],
    },
    departamentos: {
      state: ['list', 'status'],
      actions: ['fetchList', 'setCurrent'],
    },
  },

  data() {
    return {
      errorMessage: '',
    }
  },

  methods: {
    setDepartamento(p) {
      this.$store.paliari.resetState()
      this.setCurrent(p)
      this.$router.replace({ name: 'app.home' })
    },

    sair() {
      this.signOut().then(() => {
        this.$router.replace({ path: '/' })
      })
    },
  },

  created() {
    if (this.list.length === 0) {
      this.fetchList().catch(({ errors }) => {
        this.errorMessage = errors[0]
      })
    }
  },
}
</script>

<style lang="stylus" scoped>
.table
  min-width 40vw
</style>
